import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import TableHeader from '../../atoms/table/TableHeader';
import TableHeaderCell from '../../atoms/table/TableHeaderCell';
const StyledTableHeaderCell = styled(TableHeaderCell) `
    min-width: 30px;
    flex: 0;
`;
const ReportTableHeader = () => {
    return (_jsxs(TableHeader, { children: [_jsx(TableHeaderCell, { children: "Label" }), _jsx(TableHeaderCell, { children: "Filters" }), _jsx(TableHeaderCell, { children: "Frequentie" }), _jsx(TableHeaderCell, { children: "Laatste rapportage" }), _jsx(StyledTableHeaderCell, {})] }));
};
export default ReportTableHeader;
